import { STATES } from './constants.js';
import { getApiUrls } from './constants.js';
import { getRequest } from './request.js';
import {
    setFormLoader,
    removeFormLoader,
} from './form.js';

const optionsFactory = (value, text)=> {
    const optionEl = document.createElement('option');
    optionEl.value = value;
    optionEl.innerHTML = text;
    return optionEl;
};

const applyErrorStyle = (fieldEl)=> {
    const labelEl = fieldEl.previousElementSibling;
    fieldEl.classList.add('form__input--err');
    labelEl.classList.add('form__label--err');
};

const removeErrorStyle = (fieldEl)=> {
    const labelEl = fieldEl.previousElementSibling;
    fieldEl.classList.remove('form__input--err');
    labelEl.classList.remove('form__label--err');
};

const autoComplete = (cep, cb)=> {
    const { SHIPAY_CEP_URL } = getApiUrls();
    getRequest(`${SHIPAY_CEP_URL}?cep=${cep}`).then((res)=> {
        removeFormLoader();
        cb(JSON.parse(res));
    }).catch((err)=> {
        removeFormLoader();
        cb({});
    });
};

export const loadStatesList = ()=> {
    const statesEl = document.getElementById('state');
    for(const state of STATES) {
        const opEl = optionsFactory(state, state);
        statesEl.appendChild(opEl);
    }

    statesEl.value = 'SP';
}

export const handleCEPField = (cepEl, cb)=> {
    cepEl.addEventListener('input', ()=> {
        const cleanCep = cepEl.value.slice(0, 9).replace(/[\D]/g, '');
        cepEl.value = cleanCep.replace(/(\d{1,5})(\d{1,3})/g, '$1-$2').slice(0, 9);

        if(cepEl.value.length < 9) {
            applyErrorStyle(cepEl);
        }
        else {
            removeErrorStyle(cepEl);
            setFormLoader();
            autoComplete(cepEl.value, cb);
        }
    });
}
